import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import {ASML_SUB_COMPONENT_ROUTES, IN_SITE_ASML_SUB_COMPONENT_ROUTES} from "../../util/RouteConstants";
import SelectLayout, {NavigationRoutes} from "../../util/SelectLayout";
import {FeatureUtility, FEATURES} from "../../util/FeatureUtility";

class AsmlSubComponentSelectPage extends Component {
    render() {
        const routes = FeatureUtility.getFeatureStatus(FEATURES.IS_IN_SITE_ENABLED)
            ? IN_SITE_ASML_SUB_COMPONENT_ROUTES
            : ASML_SUB_COMPONENT_ROUTES;
        return (
            <Column>
                <SelectLayout routes={[...routes].sort((a,b) => {
                    return a.name.localeCompare(b.name);
                })} location={this.props.location} history={this.props.history} isComponentTypeSelect={"true"}/>
                <NavigationRoutes routes={routes}/>
            </Column>
        )
    }
}

export default AsmlSubComponentSelectPage


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/AsmlSubComponentSelectPage.js